import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import EditTeamUser from "./EditTeamUser";
import RemoveUserFromTeam from "./RemoveUserFromTeam";

const QaTeamUsersList = ({ list }) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell align="center">Edit</StyledTableCell>
              <StyledTableCell align="right">Remove User</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list?.qa_teams_users &&
              list?.qa_teams_users?.length > 0 &&
              list?.qa_teams_users?.map((row, index) => {
                return (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                      {row?.User?.name}
                    </StyledTableCell>
                    <StyledTableCell align="center" component="th" scope="row">
                      <EditTeamUser teamUser={row} />
                    </StyledTableCell>

                    <StyledTableCell align="right">
                      <RemoveUserFromTeam teamUser={row} />
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default QaTeamUsersList;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.background.paper,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
